<template>
    <div>
        <el-form-item prop="refundRuleType" label="申请退票:" :rules="[{ required: true, message: '请选择' }]">
            <el-radio-group v-model="formData.refundRuleType">
                <el-radio :label="1">不支持主动申请退票</el-radio>
                <el-radio :label="2">支持主动申请退票，对整场演出进行设置</el-radio>
				<el-radio :label="3">支持主动申请退票，对各个场次进行设置</el-radio>
            </el-radio-group>
        </el-form-item>
		<template v-if="formData && formData.refundRuleType != 1">
			<el-form-item prop="activeRefund" label="乐迷端退票通道" required>
				<el-radio-group v-model="formData.activeRefund">
					<el-radio :label="1">乐迷端开放主动申请退票通道</el-radio>
					<el-radio :label="0">乐迷端屏蔽主动申请退票通道</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item prop="refundServiceTemplateIdShow" label="将退款规则自动展示到服务模板"  v-if=" formData && formData.refundRuleType != 1 && formData && formData.activeRefund == 1">
				<el-radio-group v-model="formData.refundServiceTemplateIdShow">
					<el-radio :label="1">展示</el-radio>
					<el-radio :label="0">不展示</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item prop="refundServiceTemplateId"  v-if=" formData && formData.refundRuleType != 1  && formData && formData.activeRefund == 1 && formData && formData.refundServiceTemplateIdShow == 1">
				<el-cascader v-model="formData.refundServiceTemplateId" :options="typeOptions1" style="width:50%;" placeholder="请选择服务模板" ></el-cascader>
			</el-form-item>
			<el-form-item prop="isShowstartAudit" label="审批方" required>
				<el-radio-group v-model="formData.isShowstartAudit">
					<el-radio :label="1">秀动审批</el-radio>
					<el-radio :label="0">主办审批</el-radio>
				</el-radio-group>
			</el-form-item>
		</template>
        <template v-if="formData && formData.refundRuleType == 2">
            
			<el-card class="MT20">
				<div slot="header" class="clearfix">
					<span style="height: 30px; line-height: 30px; display: inline-block;">规则明细:</span>   
				    <el-button style="float: right;" type="primary" plain size="small" @click="setOther(formData.tourId)" >以我为主，应用到巡演其他演出</el-button>
				  </div>
            <el-form-item  class="MT20">
				
            <el-timeline>				
				<el-timeline-item timestamp="下单全额退（优先级：高）" size="large" color="#67C23A" icon="el-icon-money" placement="top">
				    <div class="timeline-main-item">
						<el-form-item prop="refundRule.orderLevel.open">
							<el-checkbox v-model="formData.refundRule.orderLevel.open" :true-label="1" :false-label="0">勾选后开启下单全额退</el-checkbox>					
						</el-form-item>						
				        <el-form-item prop="refundRule.orderLevel.node" label="">
				            <el-select v-model="formData.refundRule.orderLevel.node" size="mini">
				                <el-option :value="1" label="下单后"></el-option>
				            </el-select>
				        </el-form-item>
				        <el-form-item prop="refundRule.orderLevel.timeNum" label="" :rules="[{ required: true, message: '请填写天数或小时数' }]">
				            <el-input-number v-model="formData.refundRule.orderLevel.timeNum"  :precision="0" controls-position="right" size="mini"  @change="(value) => handleTimeNumChange(value, formData.refundRule.orderLevel, 'timeNum')"></el-input-number>
				        </el-form-item>
				        <el-form-item prop="refundRule.orderLevel.unit" label="">
				            <el-select v-model="formData.refundRule.orderLevel.unit" size="mini">
				                <el-option value="d" label="天"></el-option>
				                <el-option value="h" label="小时"></el-option>
				            </el-select>
				        </el-form-item>
				    </div>
				    <small class="color-info">
				        <template v-if="formData.refundRule.orderLevel.unit == 'd'">
				            {{ formData.refundRule.orderLevel.timeNum }}天的<span class="color-danger">24点以前</span>全额退票，填0视为{{formData.refundRule.orderLevel.node == 1 ? '下单后' : '开票后'}}当天24点以前全额退票
				        </template>
				        <template v-else>
				            {{ formData.refundRule.orderLevel.timeNum }}小时<span class="color-danger">以内</span>全额退票，填0视为{{formData.refundRule.orderLevel.node == 1 ? '下单后' : '开票后'}}<span class="color-danger">不支持全额退票</span>
				        </template>
				    </small>
				</el-timeline-item>
                <el-timeline-item timestamp="全额退票（优先级：中）" size="large" color="#67C23A" icon="el-icon-money" placement="top">
                    <div class="timeline-main-item">
						<el-form-item prop="refundRule.lastLevel.open">
							<el-checkbox v-model="formData.refundRule.lastLevel.open" :true-label="1" :false-label="0">勾选后开启全额退票</el-checkbox>					
						</el-form-item>	
                        <el-form-item prop="refundRule.lastLevel.node" label="">
                            <el-select v-model="formData.refundRule.lastLevel.node" size="mini">                                
                                <el-option :value="2" label="开票后"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="refundRule.lastLevel.timeNum" label="" :rules="[{ required: true, message: '请填写天数或小时数' }]">
                            <el-input-number v-model="formData.refundRule.lastLevel.timeNum" :precision="0" controls-position="right" size="mini"  @change="(value) => handleTimeNumChange(value, formData.refundRule.lastLevel, 'timeNum')"></el-input-number>
                        </el-form-item>
                        <el-form-item prop="refundRule.lastLevel.unit" label="">
                            <el-select v-model="formData.refundRule.lastLevel.unit" size="mini">
                                <el-option value="d" label="天"></el-option>
                                <el-option value="h" label="小时"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <small class="color-info">
                        <template v-if="formData.refundRule.lastLevel.unit == 'd'">
                            {{ formData.refundRule.lastLevel.timeNum }}天的<span class="color-danger">24点以前</span>全额退票，填0视为{{formData.refundRule.lastLevel.node == 1 ? '下单后' : '开票后'}}当天24点以前全额退票
                        </template>
                        <template v-else>
                            {{ formData.refundRule.lastLevel.timeNum }}小时<span class="color-danger">以内</span>全额退票，填0视为{{formData.refundRule.lastLevel.node == 1 ? '下单后' : '开票后'}}<span class="color-danger">不支持全额退票</span>
                        </template>
                    </small>
                </el-timeline-item>
                

                <el-timeline-item timestamp="收费退票（优先级：中）" size="large" color="#E6A23C" icon="el-icon-coin" placement="top">
                    <el-alert type="warning" show-icon :closable="false"><div slot="title">以下手续费比例，精确到1%，最低0%，最高99%，填0%视为全额退票</div></el-alert>
                    <div class="timeline-main-item MT10">
                        <el-form-item :prop="`refundRule.middleLevel[${0}].timeNum`" label="" :rules="[{ required: true, message: '请填写合理的百分比例值' }]">
                            前<el-input-number v-model="formData.refundRule.middleLevel[0].timeNum" :min="0" :max="100" :precision="0" controls-position="right" size="mini"></el-input-number>%时间段内，
                        </el-form-item>
                        <el-form-item :prop="`refundRule.middleLevel[${0}].feeRatio`" label="" :rules="[{ required: true, message: '请填写合理的百分比例值' }]">
                            扣除手续费比例<el-input-number v-model="formData.refundRule.middleLevel[0].feeRatio" :min="0" :max="99" :precision="1" controls-position="right" size="mini"></el-input-number>%
                        </el-form-item>
                    </div>
                    <div class="timeline-main-item">
                        <el-form-item :prop="`refundRule.middleLevel[${1}].timeNum`" label="" :rules="[{ required: true, message: '请填写合理的百分比例值' }]">
                            中<el-input-number v-model="formData.refundRule.middleLevel[1].timeNum" :min="0" :max="100" :precision="0" controls-position="right" size="mini"></el-input-number>%时间段内，
                        </el-form-item>
                        <el-form-item :prop="`refundRule.middleLevel[${1}].feeRatio`" label="" :rules="[{ required: true, message: '请填写合理的百分比例值' }]">
                            扣除手续费比例<el-input-number v-model="formData.refundRule.middleLevel[1].feeRatio" :min="0" :max="99" :precision="1" controls-position="right" size="mini"></el-input-number>%
                        </el-form-item>
                    </div>
                    <div class="timeline-main-item">
                        <el-form-item :prop="`refundRule.middleLevel[${2}].timeNum`" label="" :rules="[{ required: true, message: '请填写合理的百分比例值' }]">
                            后<el-input-number v-model="formData.refundRule.middleLevel[2].timeNum" :min="0" :max="100" :precision="0" controls-position="right" size="mini"></el-input-number>%时间段内，
                        </el-form-item>
                        <el-form-item :prop="`refundRule.middleLevel[${2}].feeRatio`" label="" :rules="[{ required: true, message: '请填写合理的百分比例值' }]">
                            扣除手续费比例<el-input-number v-model="formData.refundRule.middleLevel[2].feeRatio" :min="0" :max="99" :precision="1" controls-position="right" size="mini"></el-input-number>%
                        </el-form-item>
                    </div>
                </el-timeline-item>

                <el-timeline-item timestamp="不退票（优先级：最高）" size="large" color="#F56C6C" icon="el-icon-close" placement="top">
                    <el-alert type="warning" show-icon :closable="false"><div slot="title">对于通票，开演时间以最早开演的场次为准</div></el-alert>
                    <div class="timeline-main-item MT10">
                        <el-form-item prop="refundRule.firstLevel.node" label="">
                            <el-select v-model="formData.refundRule.firstLevel.node" size="mini">
                            <el-option :value="1" label="开演前"></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item prop="refundRule.firstLevel.timeNum" label="" :rules="[{ required: true, message: '请填写天数或小时数', trigger: 'blur' }
    ]">
                            <el-input-number v-model="formData.refundRule.firstLevel.timeNum" :precision="0" controls-position="right" size="mini"  @change="(value) => handleTimeNumChange(value, formData.refundRule.firstLevel, 'timeNum')"></el-input-number>
                        </el-form-item>
                        <el-form-item prop="refundRule.firstLevel.unit" label="">
                            <el-select v-model="formData.refundRule.firstLevel.unit" size="mini">
                                <el-option value="d" label="天"></el-option>
                                <el-option value="h" label="小时"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <small class="color-info">
                        <template v-if="formData.refundRule.firstLevel.unit == 'd'">
                            {{ formData.refundRule.firstLevel.timeNum }}天的<span class="color-danger">0点以后</span>，不支持退票，填0视为开演当天0点以后不支持退票
                        </template>
                        <template v-else>
                            {{ formData.refundRule.firstLevel.timeNum }}小时<span class="color-danger">以内</span>，不支持退票，填0视为直到开演后才不支持退票
                        </template>
                    </small>
                </el-timeline-item>

            </el-timeline>
            </el-form-item> 
			<el-form-item label="规则预览:">
				<table class="info-table " style="width: 100%;">
					<tr>
						<td class="rule-preview lastLevel" v-if="formData.refundRule.orderLevel.open == 1 ">
							<div class="item">
							    <div>下单后</div>
							    <template v-if="formData.refundRule.orderLevel.unit == 'd'">
							        <template v-if="formData.refundRule.orderLevel.timeNum > 0">{{ formData.refundRule.orderLevel.timeNum }}天的24点以前全额退票</template>
							        <template v-else>当天24点以前全额退票</template>
							    </template>
							    <template v-else>
							        <template v-if="formData.refundRule.orderLevel.timeNum > 0">
							            {{ formData.refundRule.orderLevel.timeNum }}小时以内全额退票
							        </template>
									<template v-if="formData.refundRule.orderLevel.timeNum == 0 && formData.refundRule.orderLevel.unit == 'h'" >不支持下单全额退</template>
							    </template>
							</div>
						</td>
						<td v-else  class="noborder"></td>
						<td class="rule-preview grayBg" v-if="formData.refundRule.orderLevel.open == 1 " >
							<div class="item" v-if="formData.refundRule.orderLevel.open == 1 " >
							    <div>超过后回到下方规则</div>
							</div>
						</td>
						<td v-else  class="noborder"></td>	
						<td rowspan="2" class="rule-preview firstLevel">
							<div class="item">
							    <div>开演前</div>
							    <template v-if="formData.refundRule.firstLevel.unit == 'd'">
							        <template v-if="formData.refundRule.firstLevel.timeNum > 0">{{ formData.refundRule.firstLevel.timeNum }}天的0点以后不支持退票</template>
							        <template v-else>开演当天0点以后不支持退票</template>
							    </template>
							    <template v-else>
							        <template v-if="formData.refundRule.firstLevel.timeNum > 0">
							            {{ formData.refundRule.firstLevel.timeNum }}小时以内不支持退票
							        </template>
							        <template v-else>直到开演后才不支持退票</template>
							    </template>
							</div>
						</td>	
					</tr>
					<tr>
						<td class="rule-preview lastLevel" v-if="formData.refundRule.lastLevel.open == 1 ">
							<div class="item">
							    <div>开票后</div>
							    <template v-if="formData.refundRule.lastLevel.unit == 'd'">
							        <template v-if="formData.refundRule.lastLevel.timeNum > 0">{{ formData.refundRule.lastLevel.timeNum }}天的24点以前全额退票</template>
							        <template v-else>当天24点以前全额退票</template>
							    </template>
							    <template v-else>
							        <template v-if="formData.refundRule.lastLevel.timeNum > 0">
							            {{ formData.refundRule.lastLevel.timeNum }}小时以内全额退票
							        </template>
									<template v-if="formData.refundRule.lastLevel.timeNum == 0 && formData.refundRule.lastLevel.unit == 'h'" >不支持开票后全额退</template>
							    </template>
							</div>							
						</td>
						<td v-else  class="noborder"></td>
						<td class="rule-preview middleLevel">
							<div class="item ">
							    <div>前面{{formData.refundRule.middleLevel[0].timeNum}}%时间段扣{{formData.refundRule.middleLevel[0].feeRatio}}%</div>
							    <div>中间{{formData.refundRule.middleLevel[1].timeNum}}%时间段扣{{formData.refundRule.middleLevel[1].feeRatio}}%</div>
							    <div>后面{{formData.refundRule.middleLevel[2].timeNum}}%时间段扣{{formData.refundRule.middleLevel[2].feeRatio}}%</div>
							</div>
						</td>						
					</tr>
				</table>
			</el-form-item>
			</el-card>
		</template>
		<template v-if="formData && sessionRefundRules && formData.refundRuleType == 3">
			<el-table :data="formData.startTimes" style="width: 100%;" size="mini" border>
			    <el-table-column prop="key" label="场次"></el-table-column>
			    <el-table-column prop="value" label="开演时间"></el-table-column>
			</el-table>
			<el-card class="MT20">
				<div slot="header" class="clearfix">
					<span style="height: 30px; line-height: 30px; display: inline-block;">规则明细:</span>
				  </div>
				  <el-timeline v-if="formData.sessionRefundRules && formData.sessionRefundRules[0] && formData.sessionRefundRules[0].orderLevel">
				  	<el-timeline-item timestamp="下单全额退（优先级：高）" size="large" color="#67C23A" icon="el-icon-money" placement="top">
				  	    <div class="timeline-main-item">
				  			<el-form-item prop="sessionRefundRules[0].orderLevel.open">
				  				<el-checkbox v-model="formData.sessionRefundRules[0].orderLevel.open" :true-label="1" :false-label="0">勾选后开启下单全额退</el-checkbox>					
				  			</el-form-item>						
				  	        <el-form-item prop="sessionRefundRules[0].orderLevel.node" label="">
				  	            <el-select v-model="formData.sessionRefundRules[0].orderLevel.node" size="mini">
				  	                <el-option :value="1" label="下单后"></el-option>
				  	            </el-select>
				  	        </el-form-item>
				  	        <el-form-item prop="sessionRefundRules[0].orderLevel.timeNum" label="" :rules="[{ required: true, message: '请填写天数或小时数' }]">
				  	            <el-input-number v-model="formData.sessionRefundRules[0].orderLevel.timeNum"  :precision="0" controls-position="right" size="mini"  @change="(value) => handleTimeNumChange(value, formData.sessionRefundRules[0].orderLevel, 'timeNum')"></el-input-number>
				  	        </el-form-item>
				  	        <el-form-item prop="sessionRefundRules[0].orderLevel.unit" label="">
				  	            <el-select v-model="formData.sessionRefundRules[0].orderLevel.unit" size="mini">
				  	                <el-option value="d" label="天"></el-option>
				  	                <el-option value="h" label="小时"></el-option>
				  	            </el-select>
				  	        </el-form-item>
				  	    </div>
				  	    <small class="color-info">
				  	        <template v-if="formData.sessionRefundRules[0].orderLevel.unit == 'd'">
				  	            {{ formData.sessionRefundRules[0].orderLevel.timeNum }}天的<span class="color-danger">24点以前</span>全额退票，填0视为{{formData.sessionRefundRules[0].orderLevel.node == 1 ? '下单后' : '开票后'}}当天24点以前全额退票
				  	        </template>
				  	        <template v-else>
				  	            {{ formData.sessionRefundRules[0].orderLevel.timeNum }}小时<span class="color-danger">以内</span>全额退票，填0视为{{formData.sessionRefundRules[0].orderLevel.node == 1 ? '下单后' : '开票后'}}<span class="color-danger">不支持全额退票</span>
				  	        </template>
				  	    </small>
				  	</el-timeline-item>
					</el-timeline>
					<el-form-item label="规则预览:">
						<table class="info-table " style="width: 100%;">
							<tr>
								<td class="rule-preview lastLevel" v-if="formData.sessionRefundRules[0].orderLevel.open == 1 ">
									<div class="item">
									    <div>下单后</div>
									    <template v-if="formData.sessionRefundRules[0].orderLevel.unit == 'd'">
									        <template v-if="formData.sessionRefundRules[0].orderLevel.timeNum > 0">{{ formData.sessionRefundRules[0].orderLevel.timeNum }}天的24点以前全额退票</template>
									        <template v-else>当天24点以前全额退票</template>
									    </template>
									    <template v-else>
									        <template v-if="formData.sessionRefundRules[0].orderLevel.timeNum > 0">
									            {{ formData.sessionRefundRules[0].orderLevel.timeNum }}小时以内全额退票
									        </template>
											<template v-if="formData.sessionRefundRules[0].orderLevel.timeNum == 0 && formData.sessionRefundRules[0].orderLevel.unit == 'h'" >不支持下单全额退</template>
									    </template>
									</div>
								</td>
								<td class="noborder" v-else style="display: none;"></td>
								<td class="rule-preview grayBg">
									<div class="item" v-if="formData.sessionRefundRules[0].orderLevel.open == 1 " >
									    <div>超过后回到下方规则</div>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退,回到下方规则</template>
									</div>
								</td>								
							</tr>							
						</table>
						<table class="info-table colorTable " style="width: 100%;">
							<tr>
								<td bgcolor="#f4cf98">阶段1</td>
								<td bgcolor="#fcca01">阶段2</td>
								<td bgcolor="#e99e42">阶段3</td>
								<td bgcolor="#bb8d62">阶段4</td>
								<td bgcolor="#a16222">阶段5</td>
							</tr>
						</table>
					</el-form-item>					
					 <table class="info-table" width="100%">
						 <thead>
							<tr>
								<th>场次</th>				    
								<th>开演时间</th>
								<th>购票时间限制</th>
								<th>阶段1</th>
								<th>阶段2</th>
								<th>阶段3</th>
								<th>阶段4</th>
								<th>阶段5</th>
								<th>操作</th>
							</tr>
						 </thead>
						<template v-if="formData.sessionRefundRules && formData.sessionRefundRules.length > 0">
							 <tr v-for="(t, index) in formData.sessionRefundRules" :key="t.sessionId">
								<td>{{t.sessionName}}</td>
								<td>{{t.sessionStartTime}}</td>
								<td class="color-danger hand"  @click="addBuyTime(index)">
									<template v-if="t.buyTimeStart || t.buyTimeEnd">
										<p v-if="t.buyTimeStart">起：{{ t.buyTimeStart }}</p>
										<p v-if="t.buyTimeEnd">止：{{ t.buyTimeEnd }}</p>
										<p class="font10">在以上时间段内购票才允许退票</p>
									</template>
									<div v-else class="color-blue" @click="addBuyTime(index)">
										暂未设置
									</div>
								</td>
								<td  class="color-blue hand" @click="addTime(index,0)">
									<template v-if="t.refundRules[0]" >
										<p v-if="t.refundRules[0].startTime">起：{{ t.refundRules[0].startTime }}</p>
										<p v-if="t.refundRules[0].endTime">止：{{ t.refundRules[0].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[0].serviceFeeRatio }}%</p>
									</template>
									<div v-else class="color-blue" >
										暂未设置
									</div>
								</td>
								<td class="color-blue hand" @click="addTime(index,1)" >
									<template  v-if="t.refundRules[1]">
										<p v-if="t.refundRules[1].startTime">起：{{ t.refundRules[1].startTime }}</p>
										<p v-if="t.refundRules[1].endTime">止：{{ t.refundRules[1].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[1].serviceFeeRatio }}%</p>
									</template>
									<div v-else @click="addTime(index,1)">
										暂未设置
									</div>
								</td>
								<td  class="color-blue hand" @click="addTime(index,2)">
									<template  v-if="t.refundRules[2]">
										<p v-if="t.refundRules[2].startTime">起：{{ t.refundRules[2].startTime }}</p>
										<p v-if="t.refundRules[2].endTime">止：{{ t.refundRules[2].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[2].serviceFeeRatio }}%</p>
									</template>
									<div v-else  @click="addTime(index,2)">
										暂未设置
									</div>
								</td>
								<td class="color-blue hand" @click="addTime(index,3)">
									<template  v-if="t.refundRules[3]">
										<p v-if="t.refundRules[3].startTime">起：{{ t.refundRules[3].startTime }}</p>
										<p v-if="t.refundRules[3].endTime">止：{{ t.refundRules[3].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[3].serviceFeeRatio }}%</p>
									</template>
									<div v-else @click="addTime(index,3)">
										暂未设置
									</div>
								</td>
								<td class="color-blue hand" @click="addTime(index,4)">
									<template  v-if="t.refundRules[4]">
										<p v-if="t.refundRules[4].startTime">起：{{ t.refundRules[4].startTime }}</p>
										<p v-if="t.refundRules[4].endTime">止：{{ t.refundRules[4].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[4].serviceFeeRatio }}%</p>
									</template>
									<div v-else  @click="addTime(index,4)">
										暂未设置
									</div>
								</td>
								<td class="color-blue hand" v-if="formData.sessionRefundRules.length > 1"><span class="el-icon-edit" @click="batchSet(index)">以我为准，批量设置其他场次</span></td>
							</tr>
						</template>				
					</table>
					<div class="color-danger MT10">购票时间限制：用户在对应时间段内购票才能申请退票，不设置视为不对购票时间做要求。<br>以上每个场次最多设置5个扣费阶段，通票以最早开演场次的规则为准。</div>
			</el-card>			
		</template>
		<template v-if="formData && formData.refundRuleType != 1 ">
			<el-form-item prop="refundFeeDivide" label="手续费秀动分成占比:" :rules="[{required:true,message:'请填写手续费秀动分成占比'}]" class="MT20">
				<el-row :gutter="10">
					<el-col :span="22">
						<el-input-number style="width:100%" v-model="formData.refundFeeDivide" controls-position="right" :min="0" :max="100" :precision="1"></el-input-number>
					</el-col>
					<el-col :span="2">%</el-col>
				</el-row>
				<el-alert  type="warning" :closable="false" style="line-height:1.5;margin-top: 10px;">
					<p>影响结算给主办的手续费金额，比如100元门票，对乐迷扣除手续费10%=10元，然后<span class="color-danger">秀动保留10*X%元，结算给主办：10-10*X%</span></p>
				</el-alert>
			</el-form-item>
		</template>
		<el-dialog title="退费手续费" :visible.sync="dialogVisible" width="500px" center :close-on-click-modal="false">
			<div class="dialog-content">
				<el-form :model="copyInfo" ref="copyInfo">
					<el-form-item prop="startTime" label="起始时间:" :rules="[{required: true, message: '请输入起始时间'}]">						
						<el-date-picker
						  size="small"
						  v-model="copyInfo.startTime"
						  type="datetime"
						  placeholder="起始时间">
						</el-date-picker>					
					</el-form-item>
					<el-form-item prop="endTime" label="结束时间:"  :rules="[{required: true, message: '请输入结束时间'}]">						
						<el-date-picker
						  size="small"
						  v-model="copyInfo.endTime"
						  type="datetime"
						  placeholder="结束时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="ratio" label="扣除手续费比例:"  :rules="[{required: true, message: '请输入扣除手续费比例'}]">
						<el-input-number style="width:30%;" v-model="copyInfo.ratio" :min="0" :max="99"
						    :controls="false" :precision='1'></el-input-number> %
							<small class="color-danger">精确到1%，最低0%，最高99%，5个阶段以外的时间均视为不支持退票。</small>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<div style="display: flex; align-items: center;">
					<el-button type="primary" @click="addTimefun()">确 定</el-button>
					<div><small class="color-danger" style="text-align: left; margin-left: 10px;">请检查是否存在空缺时间段<br>用户无法在未设置的时间段申请退票</small></div>
				</div>				
			</span>
		</el-dialog>
		<el-dialog title="购票时间限制" :visible.sync="BuydialogVisible" width="500px" center :close-on-click-modal="false" >
			<div class="dialog-content">
				<el-form :model="copybuyInfo" ref="copybuyInfo">
					<el-form-item prop="buyTimeStart" label="起始时间:" :rules="[{required: true, message: '请输入起始时间'}]">						
						<el-date-picker
						  size="small"
						  v-model="copybuyInfo.buyTimeStart"
						  type="datetime"
						  placeholder="起始时间">
						</el-date-picker>					
					</el-form-item>
					<el-form-item prop="buyTimeEnd" label="结束时间:"  :rules="[{required: true, message: '请输入结束时间'}]">						
						<el-date-picker
						  size="small"
						  v-model="copybuyInfo.buyTimeEnd"
						  type="datetime"
						  placeholder="结束时间">
						</el-date-picker>
					</el-form-item>					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<div style="display: flex; align-items: center;">
					<el-button type="primary" @click="addbuytimeFun()">确 定</el-button>
				</div>				
			</span>
		</el-dialog>
		<other-activity ref="OtherActivity" :activityId="formData.activityId"></other-activity>
    </div>
</template>
<script>
import {fetchServiceTemplateType} from '@/assets/js/commonApi'
import OtherActivity from './other-activity.vue';
export default {
    props: {
        formData: {
            type: Object,
            default: null
        },
		sessionRefundRules: {
		    type: Array,
		    default: () => []
		},
    },
	components: {
		OtherActivity
	},
    data() {
        return {
			dialogVisible:false,
			BuydialogVisible:false,
			copyInfo: {
				num:0,
				index:0,
				startTime:null,
				endTime:null,
				ratio:null,
			},
			copybuyInfo:{
				index:0,
				buyTimeStart:null,
				buyTimeEnd:null,
			},
			pickerOptions:{
			    disabledDate(time) {
			        return time.getTime() < Date.now();
			    },
			},
			num:'',
			timeIndex:'',
			typeOptions1: [],
			serviceTemplate:[],
			serviceTemplateType:[],
			
			
			
        }
    },
	mounted() {
		this.serviceTemplateType =  fetchServiceTemplateType();
		// const _typeList = fetchServiceTemplateType();		
		// const _Activity = _typeList.filter((item) => item.value != 0);
		// this.typeOptions1 = [
		// 	{ label: "服务说明", value: 1 , children: [..._Activity ]},
		// 	{ label: "购票须知", value: 2 , children: [..._Activity ]},
		// 	{ label: "观演须知", value: 3 , children: [..._Activity ]},
		// ]
		this.getTemplate()
	},
    methods: {
		handleTimeNumChange(value, parentObj, fieldName) {
		    if (value !== null && value !== undefined && value !== '') {
		      if (value < 0 || value > 1000) {
		        parentObj[fieldName] = undefined;
		        return this.$message.error('请填写合理的数值,大于0小于1000');
		      }
		    }
		  },
		getTemplate(){
		    this.serviceTemplateList = []; 
		    this.$request({
		        url: "/activity/getTemplate",
				params: {activityId: this.id},
		        method: "post",
		    }).then(res => {
		        const { state, result , msg } = res.data;
		        if(state == 1 && result){
		            this.serviceTemplate = result
					var level1List = [{
							value: 1,
							label: '服务说明'
						}, {
							value: 2,
							label: '购票须知'
						}, {
							value: 3,
							label: '观演须知'
						}];
		            var newLevel = [];
						for (let key1 in this.serviceTemplate) {
						        var level1 = JSON.parse(JSON.stringify(level1List.find(v => v.value == key1)));
						        level1.children = []
						        for (let key2 in this.serviceTemplate[key1]) {
						            var level2 = JSON.parse(JSON.stringify(this.serviceTemplateType.find(v => v.value == key2)));
						            level2.children = []
						            for (let key3 in this.serviceTemplate[key1][key2]) {
						                level2.children.push({
						                    value: this.serviceTemplate[key1][key2][key3].id,
						                    label: this.serviceTemplate[key1][key2][key3].title + '[' + this.serviceTemplate[key1][key2][key3].id + ']'
						                })
						            }
						            level1.children.push(level2)
						        }
						        newLevel.push(level1)
						    }
						
						this.typeOptions1 = newLevel
						
		        }else{
		            this.$message.error(msg && "获取购票须知失败");
		        }
		    })
		},
		setOther(tourId){
			console.log(tourId)
			this.$refs.OtherActivity.show(tourId);
		},
		addTime(num,index){
			
			this.copyInfo.num = num
			this.copyInfo.index = index
			this.copyInfo.startTime = null
			this.copyInfo.endTime = null
			this.copyInfo.ratio = null		
			
			if( this.formData.sessionRefundRules[num].refundRules[index] != null){
				var refundRules = this.formData.sessionRefundRules[num].refundRules[index]				
				this.copyInfo.startTime = refundRules.startTime
				this.copyInfo.endTime = refundRules.endTime
				this.copyInfo.ratio = refundRules.serviceFeeRatio
			}else{
				this.copyInfo.startTime = ''
				this.copyInfo.endTime = ''
				this.copyInfo.ratio = 0
			}
			this.dialogVisible = true;			
		},
		addTimefun(){
			this.$refs["copyInfo"].validate((valid) => {
				if (valid) {
					var startTime = this.$utils.formatDate(this.copyInfo.startTime, 'yyyy-MM-dd HH:mm:ss')
					var endTime = this.$utils.formatDate(this.copyInfo.endTime, 'yyyy-MM-dd HH:mm:ss')
					
					
					if (this.$utils.compareDate(startTime, endTime)) {
					    this.$message.error('开始时间必须小于结束时间');
					    return;
					}
					var refundRules = {}
					refundRules.startTime = startTime
					refundRules.endTime = endTime
					refundRules.serviceFeeRatio = this.copyInfo.ratio
					this.$set(this.formData.sessionRefundRules[this.copyInfo.num].refundRules,this.copyInfo.index,refundRules)					
					this.dialogVisible = false;					
					
					document.documentElement.scrollTop = document.body.scrollTop = 0;
				}
			})
		},
		batchSet(index){			
			this.$confirm(`是否确认以该场次的设置为准，批量设置其他场次?<br><span class="color-danger">确认后，仍然需要提交整个表单才会生效。</span>`, '批量设置其他场次', {			
			center: false,
			closeOnClickModal: false,
			dangerouslyUseHTMLString: true,	
			}).then(() => {
				var refundRulesData = this.formData.sessionRefundRules[index];
				
				
				this.formData.sessionRefundRules.forEach((item, index) => {
					this.formData.sessionRefundRules[index].refundRules = [...refundRulesData.refundRules]
					this.formData.sessionRefundRules[index].buyTimeStart = refundRulesData.buyTimeStart
					this.formData.sessionRefundRules[index].buyTimeEnd = refundRulesData.buyTimeEnd
					
				})
			}).catch(() => {})
		},
		addBuyTime(index){
			
			this.BuydialogVisible = true;
			this.copybuyInfo.startTime = null
			this.copybuyInfo.endTime = null
			this.copybuyInfo.index = index
			
			if( this.formData.sessionRefundRules[index] ){
				var refundRules = this.formData.sessionRefundRules[index]		
				this.copybuyInfo.buyTimeStart = refundRules.buyTimeStart
				this.copybuyInfo.buyTimeEnd = refundRules.buyTimeEnd
			}else{
				this.copybuyInfo.buyTimeStart = ''
				this.copybuyInfo.buyTimeEnd = ''
			}
		},
		addbuytimeFun(){
			this.$refs["copybuyInfo"].validate((valid) => {
				if (valid) {
					var startTime = this.$utils.formatDate(this.copybuyInfo.buyTimeStart, 'yyyy-MM-dd HH:mm:ss')
					var endTime = this.$utils.formatDate(this.copybuyInfo.buyTimeEnd, 'yyyy-MM-dd HH:mm:ss')
					
					
					if (this.$utils.compareDate(startTime, endTime)) {
					    this.$message.error('开始时间必须小于结束时间');
					    return;
					}
					
					this.formData.sessionRefundRules[this.copybuyInfo.index].buyTimeStart = startTime
					this.formData.sessionRefundRules[this.copybuyInfo.index].buyTimeEnd = endTime
					
					this.BuydialogVisible = false;
					document.documentElement.scrollTop = document.body.scrollTop = 0;
				}
			})
		},
		
    }
}
</script>

<style lang="scss" scoped>
.timeline-main-item{
    display: flex;
    align-items: center;
    .el-form-item{
        flex: 1;
        .el-select .el-input{
            min-width: auto;
        }
    }
    .el-input-number{
        margin:0 10px;
    }
    ::v-deep .el-form-item__content{
        font-size: 12px;
        display: flex;
        align-items: center;
        line-height: normal;
    }
    ::v-deep .el-input-number--mini{
        width: auto;
        flex: 1;
        min-width: 80px;
    }
}
::v-deep .el-timeline-item__timestamp{
    color: #333;
}
 .info-table tr td{
	padding:0
}
::v-deep .info-table tr th{
	padding:5px 0 5px 20px
}
::v-deep .el-card__header{
	padding:10px 20px;
	
}
.noborder{
	border: 1px solid #fff;
}
.rule-preview{	
	color: #fff;
	border: none;
	border-bottom: 2px solid #eee;	
    .item{
		padding:10px;
        
        font-size: 12px;
        line-height: normal;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
    }
    &.lastLevel{
        background-color: $--color-success;
    }
    &.middleLevel{
        background-color: $--color-warning;
    }
    &.firstLevel{
        background-color: $--color-danger;
    }
	&.grayBg{
		background-color: #999;
		color:#333
	}
}
.hand{
	cursor: pointer;
}
td{
	border-right:1px solid #eee;
}
td:last-child{
	
}
.font10{
	margin-top: 8px;
	font-size: 10px;
}
.colorTable{
	border-width: 0;
	td{
		border-width: 0;
		padding:0;
		text-align: center;
		color:#fff
	}
}
</style>